import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss"; // Adjust the import path as needed
import { Button } from "../../common/components/Button"; // Adjust the import path as needed
// import { infinipathMeet } from "../../assets/images/infinipathImg.webp"; // Adjust the import path as needed
import entrainmentBanner from "../../assets/images/ent-banner-logo-25-v1.webp";
import entrainmentLogo from "../../assets/images/ent-logo-v1.svg"; // Adjust the import path as needed
import {
  formatDate,
  formatDateRangeToIST,
  formatTime,
  contentDateFormat,
  formatPriceWithCommas,
  extractTime,
} from "../../utils/commonFunctions";
import {
  checkRegistrationWindowStatusOfEntrainment,
  stringToNumber,
} from "../../utils/registrationUtils";
import ProgramInfoCardV2 from "../ProgramInfoCardV2";
import {
  getCallEntrainment,
  postCallEntrainment,
} from "../../services/apiService";
import { endPoints } from "../../constants/urlConstants";
import { ENT_TEXT_CONSTANTS } from "../../constants/entTextConstants";
import animationVideo from "../../assets/images/animationVideo.webm";
import { setItemInLocalStorage } from "../../services/localStorage";
import mobileBannerAnimation from "../../assets/images/mobile-banner-animation.webm"; // Adjust the import path as needed
import { validateSeekerStatus } from "../../utils/entrainmentUtils";
import mobileMahatriaImg from "../../assets/images/mobile-mahatria.webp";
interface EntrainmentProps {
  handleRegister?: (id: string) => void;
  seekerDetails: any;
  programDetails?: any;
  setLoader: (loading: boolean) => void;
  setShowSnackbar: (show: boolean) => void;
  setSnackbarMessage: (message: string) => void;
  setSnackBarIcon: (icon: string) => void;
}

interface Registration {
  programRegistrationId: number;
  fullName: string;
  status: string;
  paymentTypeStatus?: string;
  travelStatus?: string;
  paymentToken?: string;
  travelToken?: string;
  paymentMode?: string;
  waitlistLinkReleased?: boolean;
  logisticStatus?: string;
  programRegistrationSeqNumber?: string;
  invoiceSeqNumber?: string;
  hasSeatTransfer?: boolean; // Indicates if the seat has been transferred
  selfMobileSeatTransfer?: boolean; // Indicates if the seat is transferred by the user themselves
  // Add other fields as needed
}

const Entrainment: React.FC<EntrainmentProps> = ({
  seekerDetails,
  programDetails,
  setLoader,
  setShowSnackbar,
  setSnackbarMessage,
  setSnackBarIcon,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [registrations, setRegistrations] = useState<Registration[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isWaitingList, setIsWatingList] = useState<boolean>(false);
  const [showRegisterButton, setShowRegisterButton] = useState<boolean>(false);
  const [registrationMessage, setRegistrationMessage] = useState<string>("");
  const [isMobileResolution, setIsMobileResolution] = useState(false);
  // "Registrations for Entrainment 25 open on 04 September 2025 at 11:30 a.m. IST"
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  // console.log("Seeker Details:", seekerDetails);

  //Funtion to fetch entrainment registrations
  const fetchEntrainmentRegistrations = async (isRefreshClicked: boolean) => {
    try {
      // setIsLoading(true);
      setError(null);
      const queryParams = new URLSearchParams({
        // userId: seekerDetails?.id || "",
        programId: "2",
        // mobile:
        //   (seekerDetails?.countryCode?.replace("+", "") || "") +
        //   (seekerDetails?.phoneNumber || ""),
      }).toString();
      const response = await getCallEntrainment(
        `${endPoints.getEntrainmentRegistrations}?${queryParams}`,
      );

      if (response?.status === 200) {
        // console.log("Registrations response:", response);
        setRegistrations(response?.data?.data || []);
        // Generate array of already registered user names and store in local storage
        const alreadyRegisteredUsers = (response?.data?.data || []).map(
          (registration: Registration) =>
            registration.fullName?.trim()?.toLowerCase(),
        );
        // console.log("Already Registered Users:", alreadyRegisteredUsers);
        setItemInLocalStorage(
          "alreadyRegisteredUsers",
          JSON.stringify(alreadyRegisteredUsers),
        );

        // Store the registration data in local storage
        setItemInLocalStorage(
          "selfRegistrationExists",
          JSON.stringify(response?.data?.selfRegistrationExists),
        );
      } else {
        setRegistrations([]);
        setItemInLocalStorage("selfRegistrationExists", JSON.stringify(false));
      }
    } catch (error) {
      setItemInLocalStorage("selfRegistrationExists", JSON.stringify(false));
      setError("Failed to fetch entrainment registrations");
      console.error("Error fetching registrations:", error);
    } finally {
      // setIsLoading(false);
      if (isRefreshClicked) {
        setShowSnackbar(true);
        setSnackBarIcon("success");
        setSnackbarMessage(ENT_TEXT_CONSTANTS.REFRESH_SUCCESS);
      }
    }
  };

  // Function to fetch entrainment seats status
  const fetchEntrainmentSeatsStatus = async () => {
    try {
      setError(null);
      const response = await getCallEntrainment(
        endPoints.getEntrainmentSeatsStatus(2),
      );
      if (response?.status === 200) {
        setIsWatingList(response?.data?.remainingSeats <= 0);
      }
    } catch (error) {
      setError("Failed to fetch entrainment seats status");
      console.error("Error fetching seats status:", error);
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEntrainmentSeatsStatus();
    fetchEntrainmentRegistrations(false);
  }, []);

  const downloadFile = async (url: string, filename: string) => {
    try {
      // Fetch the file as blob to force download
      const response = await fetch(url);
      const blob = await response.blob();

      // Create object URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      setLoader(false);

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      setLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage(ENT_TEXT_CONSTANTS.DOWNLOAD_FAILED);
      console.error("Error downloading file:", error);
      // Fallback to original method if fetch fails
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }
  };

  const handleDownloadInvoice = async (registration: Registration) => {
    setLoader(true);
    const invoiceUrl = endPoints.downloadInvoice(
      registration?.programRegistrationId,
    );
    const payload = { programRegId: registration?.programRegistrationId };
    try {
      const response = await postCallEntrainment(invoiceUrl, payload);
      if (response.data?.data?.fileLocation) {
        // const currentDate = new Date();
        // const formattedDate = currentDate.toISOString().slice(0, 10);
        const filename = `${registration?.invoiceSeqNumber ? registration?.invoiceSeqNumber : registration?.programRegistrationSeqNumber}.pdf`;
        await downloadFile(response.data?.data?.fileLocation, filename);
      }
    } catch (error) {
      setLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage(ENT_TEXT_CONSTANTS.DOWNLOAD_FAILED);
      console.error("Error downloading invoice:", error);
    }
  };

  //Function to handle navigation
  const handleNavigation = async () => {
    setLoader(true);
    const programRegWindowStatus =
      await checkRegistrationWindowStatusOfEntrainment();
    if (programRegWindowStatus) {
      const paramsObject: Record<string, string> = {
        source: "portal",
      };

      const params = new URLSearchParams(paramsObject);

      // Check if running locally
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      const baseUrl = isLocalhost
        ? "http://localhost:4200"
        : window.location.origin;

      window.location.href = `${baseUrl}/entrainment/registration-form?${params.toString()}`;
    } else {
      setLoader(false);
      // Handle case where registration window is closed
      setShowSnackbar(true);
      setSnackbarMessage(ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT);
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Hide snackbar after 2 seconds
    }
  };

  const handleSubNavigation = async (
    paymentStatus?: string,
    token?: string,
    paymentType?: string,
    programRegistrationId?: number,
  ) => {
    setLoader(true);
    let latestRegistrations;
    try {
      const queryParams = new URLSearchParams({
        programId: "2",
      }).toString();
      const response = await getCallEntrainment(
        `${endPoints.getEntrainmentRegistrations}?${queryParams}`,
      );
      if (response?.status === 200) {
        latestRegistrations = response?.data?.data || [];
        setRegistrations(response?.data?.data || []);
        setItemInLocalStorage(
          "selfRegistrationExists",
          JSON.stringify(response?.data?.selfRegistrationExists),
        );

        // Generate array of already registered user names and store in local storage
        const alreadyRegisteredUsers = (response?.data?.data || []).map(
          (registration: Registration) =>
            registration.fullName?.trim()?.toLowerCase(),
        );
        setItemInLocalStorage(
          "alreadyRegisteredUsers",
          JSON.stringify(alreadyRegisteredUsers),
        );
      } else {
        setLoader(false);
        setRegistrations([]);
        setItemInLocalStorage("selfRegistrationExists", JSON.stringify(false));
      }
    } catch (error) {
      setLoader(false);
      setRegistrations([]);
      setItemInLocalStorage("selfRegistrationExists", JSON.stringify(false));
      setError("Failed to fetch entrainment registrations");
      console.error("Error fetching registrations:", error);
    }

    // console.log(registrations, "RegistrationsLatest", programRegistrationId);
    // console.log("Payment Status:", paymentStatus, paymentType, token);

    const isValidSeeker = validateSeekerStatus(
      latestRegistrations,
      programRegistrationId,
    );

    if (!isValidSeeker) {
      setLoader(false);
      setShowSnackbar(true);
      setSnackBarIcon("error");
      setSnackbarMessage(ENT_TEXT_CONSTANTS.REGISTRATION_STATUS_UPDATED);
      return;
    } else {
      // Check if running locally
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      const baseUrl = isLocalhost
        ? "http://localhost:4200"
        : window.location.origin;

      // Case 1: No payment type - go to billing
      if (!paymentType) {
        window.location.href = `${baseUrl}/entrainment/billing?${token}`;
        return;
      }

      // Case 2: Offline payment type - go to travel page
      if (paymentType.toLowerCase().includes("offline")) {
        window.location.href = `${baseUrl}/entrainment/entrainment-travel-page?${token}`;
        return;
      }

      // Case 3: Online payment type
      if (paymentType.toLowerCase().includes("online")) {
        // For pending or failed payments - go to billing
        if (
          !paymentStatus ||
          paymentStatus.toLowerCase().includes("pending") ||
          paymentStatus.toLowerCase().includes("failed")
        ) {
          window.location.href = `${baseUrl}/entrainment/billing?${token}`;
          return;
        }

        // For completed payments - go to travel page
        if (
          paymentStatus.toLowerCase().includes("completed") ||
          paymentStatus.toLowerCase().includes("done")
        ) {
          window.location.href = `${baseUrl}/entrainment/entrainment-travel-page?${token}`;
          return;
        }
      }
    }
  };

  const getStatusContent = (registration: Registration) => {
    const status = registration?.status?.toLowerCase() || "";
    const paymentType = registration?.paymentMode?.toLowerCase() || "";
    const paymentStatus = registration?.paymentTypeStatus?.toLowerCase() || "";
    const travelStatus = registration?.travelStatus?.toLowerCase() || "";
    const waitlistLinkReleased = registration?.waitlistLinkReleased || false;
    const logisticStatus = registration?.logisticStatus?.toLowerCase() || "";
    const registrationWindowStatus = programDetails?.registrationWindowStatus;

    if (status?.includes("denied")) {
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.DENIED_TEXT}</p>
        </div>
      );
    }

    if(status?.includes("first page pending")){
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.THANK_YOU}</p>
        </div>
      );
    }

    // Case 1: Waiting List
    if (status.includes("waiting")) {
      if (
        waitlistLinkReleased &&
        registrationWindowStatus !== ENT_TEXT_CONSTANTS.REG_CLOSED
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.WAITLIST_LINK_RELEASED}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_PAYMENT}</p>
          </div>
        );
      } else {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.THANK_YOU}</p>
            {registrationWindowStatus !== ENT_TEXT_CONSTANTS.REG_CLOSED && (
              <p>{ENT_TEXT_CONSTANTS.USER_WAITING_LIST}</p>
            )}
          </div>
        );
      }
    }

    // Cancelled Case
    if (status.includes("cancelled")) {
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.CANCELLED_TEXT}</p>
        </div>
      );
    }

    //Case 0: System is in waiting list
    if (
      isWaitingList &&
      (!paymentStatus ||
        (paymentStatus?.includes("pending") && paymentType?.includes("online")))
    ) {
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS?.THANK_YOU}</p>
          {registrationWindowStatus !== ENT_TEXT_CONSTANTS.REG_CLOSED && (
            <p>{ENT_TEXT_CONSTANTS?.SYSTEM_WAITING_LIST}</p>
          )}
        </div>
      );
    }

    // Case 2: Payment Completed & Travel Completed
    if (
      (paymentStatus.includes("completed") || paymentStatus.includes("done")) &&
      (travelStatus.includes("completed") || travelStatus.includes("done")) &&
      (logisticStatus.includes("completed") || logisticStatus.includes("done"))
    ) {
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_ONLINE}</p>
          <p>
            <span
              className={styles.link2}
              onClick={() => handleDownloadInvoice(registration)}
            >
              {ENT_TEXT_CONSTANTS.INVOICE_DOWNLOAD}
            </span>
          </p>
        </div>
      );
    }

    //Case: First Page pending
    if (!paymentType && !paymentStatus && !travelStatus) {
      return (
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.THANK_YOU}</p>
          {registrationWindowStatus !== ENT_TEXT_CONSTANTS.REG_CLOSED && (
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_PAYMENT}</p>
          )}
        </div>
      );
    }

    // Case 3: Offline Payment Handling
    if (paymentType === "offline") {
      //RELEASE SEAT HANDLING STARTS HERE
      if (
        waitlistLinkReleased &&
        paymentStatus.includes("pending") &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.WAITLIST_LINK_RELEASED}</p>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_OFFLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.OFFLINE_NOTE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
          </div>
        );
      }
      if (
        waitlistLinkReleased &&
        (paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.WAITLIST_LINK_RELEASED}</p>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_ONLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
            <p>
              <span
                className={styles.link2}
                onClick={() => handleDownloadInvoice(registration)}
              >
                {ENT_TEXT_CONSTANTS.INVOICE_DOWNLOAD}
              </span>
            </p>
          </div>
        );
      }
      if (
        waitlistLinkReleased &&
        paymentStatus.includes("pending") &&
        (travelStatus.includes("completed") || travelStatus.includes("done"))
      ) {
        <div className={styles.statusContent}>
          <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_OFFLINE}</p>
        </div>;
      }
      if (
        paymentStatus.includes("pending") &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_OFFLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.OFFLINE_NOTE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
          </div>
        );
      }
      //RELEASE SEAT HANDLING ENDS HERE

      if (
        (paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_ONLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
            <p>
              <span
                className={styles.link2}
                onClick={() => handleDownloadInvoice(registration)}
              >
                {ENT_TEXT_CONSTANTS.INVOICE_DOWNLOAD}
              </span>
            </p>
          </div>
        );
      }

      if (
        paymentStatus.includes("pending") &&
        (travelStatus.includes("completed") || travelStatus.includes("done")) &&
        (logisticStatus.includes("completed") ||
          logisticStatus.includes("done"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_OFFLINE}</p>
          </div>
        );
      }
    }

    // Case 4: Online Payment Handling
    if (paymentType === "online") {
      //RELEASE SEAT HANDLING ONLINE STARTS HERE
      if (
        waitlistLinkReleased &&
        (paymentStatus.includes("pending") || paymentStatus.includes("failed"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.WAITLIST_LINK_RELEASED}</p>
            {registrationWindowStatus !== ENT_TEXT_CONSTANTS.REG_CLOSED && (
              <p>{ENT_TEXT_CONSTANTS.PAYMENT_PENDING}</p>
            )}
          </div>
        );
      }
      if (
        waitlistLinkReleased &&
        (paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.WAITLIST_LINK_RELEASED}</p>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_ONLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
            <p>
              <span
                className={styles.link2}
                onClick={() => handleDownloadInvoice(registration)}
              >
                {ENT_TEXT_CONSTANTS.INVOICE_DOWNLOAD}
              </span>
            </p>
          </div>
        );
      }
      //RELEASE SEAT HANDLING ONLINE ENDS HERE
      if (
        paymentStatus.includes("pending") ||
        paymentStatus.includes("failed")
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_PENDING}</p>
          </div>
        );
      }

      if (
        (paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.statusContent}>
            <p>{ENT_TEXT_CONSTANTS.PAYMENT_ACKNOWLEDGEMENT_ONLINE}</p>
            <p>{ENT_TEXT_CONSTANTS.PROCEED_TO_TRAVEL}</p>
            <p>
              <span
                className={styles.link2}
                onClick={() => handleDownloadInvoice(registration)}
              >
                {ENT_TEXT_CONSTANTS.INVOICE_DOWNLOAD}
              </span>
            </p>
          </div>
        );
      }
    }

    return null;
  };

  const renderActionButton = (registration: Registration) => {
    const status = registration?.status?.toLowerCase() || "";
    const paymentType = registration?.paymentMode?.toLowerCase() || "";
    const paymentStatus = registration?.paymentTypeStatus?.toLowerCase() || "";
    const travelStatus = registration?.travelStatus?.toLowerCase() || "";
    const waitlistLinkReleased = registration?.waitlistLinkReleased || false;
    const logisticStatus = registration?.logisticStatus?.toLowerCase() || "";
    const registrationWindowStatus = programDetails?.registrationWindowStatus;
    const seatTransferred = registration?.hasSeatTransfer || false;
    const selfTransferredSeat = registration?.selfMobileSeatTransfer || false;

    if(seatTransferred && !selfTransferredSeat){
      return (
          <div className={styles.actionColumn}>
            <p>{ENT_TEXT_CONSTANTS.SEAT_TRANSFERRED_TEXT}</p>
          </div>
        );
    }
    
    if (status?.includes("denied")) {
      return null;
    }
    // Waiting List Case
    if (status.includes("waiting")) {
      if (waitlistLinkReleased) {
        if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_CLOSED) {
          return (
            <div className={styles.actionColumn}>
              <p>{ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT_AT_ACTION}</p>
            </div>
          );
        } else {
          return (
            <div className={styles.actionColumn}>
              <Button
                buttonClassName={styles.confirmButton}
                buttonTextClassName={styles.confirmText}
                onClick={() =>
                  handleSubNavigation(
                    registration?.paymentTypeStatus,
                    registration?.paymentToken,
                    registration?.paymentMode,
                    registration?.programRegistrationId,
                  )
                }
              >
                pay now
              </Button>
            </div>
          );
        }
      } else {
        if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_CLOSED) {
          return (
            <div className={styles.actionColumn}>
              <p>{ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT_AT_ACTION}</p>
            </div>
          );
        } else {
          return (
            <div className={styles.actionColumn}>
              <p>waiting list...</p>
            </div>
          );
        }
      }
    }

    // Cancelled Case
    if (status.includes("cancelled")) {
      return null;
    }

    // Both Payment, Travel and Logistics Completed
    if (
      (paymentStatus.includes("completed") || paymentStatus.includes("done")) &&
      (travelStatus.includes("completed") || travelStatus.includes("done")) &&
      (logisticStatus.includes("completed") || logisticStatus.includes("done"))
    ) {
      return (
        <div className={styles.actionColumn}>
          <p>You are all set !!</p>
        </div>
      );
    }

    if (!paymentType) {
      if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_CLOSED) {
        return (
          <div className={styles.actionColumn}>
            <p>{ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT_AT_ACTION}</p>
          </div>
        );
      } else {
        return (
          <div className={styles.actionColumn}>
            <Button
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
              onClick={() =>
                handleSubNavigation(
                  registration?.paymentTypeStatus,
                  registration?.paymentToken,
                  registration?.paymentMode,
                  registration?.programRegistrationId,
                )
              }
            >
              pay now
            </Button>
          </div>
        );
      }
    }

    // Offline Payment Type
    if (paymentType.includes("offline")) {
      if (
        ((paymentStatus.includes("pending") ||
          paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
          (!travelStatus || travelStatus.includes("pending"))) ||
        !logisticStatus ||
        logisticStatus.includes("pending")
      ) {
        return (
          <div className={styles.actionColumn}>
            <div className={styles.actionColumnContent}>
            <Button
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
              onClick={() =>
                handleSubNavigation(
                  registration?.paymentTypeStatus,
                  registration?.travelToken,
                  registration?.paymentMode,
                  registration?.programRegistrationId,
                )
              }
            >
              update details
            </Button>
            {seatTransferred && selfTransferredSeat && <p>{ENT_TEXT_CONSTANTS.SEAT_TRANSFERRED_TEXT}</p>}
            </div>
          </div>
        );
      }
    }

    // Online Payment Type
    if (paymentType.includes("online")) {
      // Show Pay Now for pending/failed payments
      if (
        paymentStatus.includes("pending") ||
        paymentStatus.includes("failed")
      ) {
        if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_CLOSED) {
          return (
            <div className={styles.actionColumn}>
              <p>{ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT_AT_ACTION}</p>
            </div>
          );
        } else {
          return (
            <div className={styles.actionColumn}>
              <Button
                buttonClassName={styles.confirmButton}
                buttonTextClassName={styles.confirmText}
                onClick={() =>
                  handleSubNavigation(
                    registration?.paymentTypeStatus,
                    registration?.paymentToken,
                    registration?.paymentMode,
                    registration?.programRegistrationId,
                  )
                }
              >
                retry payment
              </Button>
            </div>
          );
        }
      }

      // Show Plan Travel for completed payments
      if (
        (paymentStatus.includes("completed") ||
          paymentStatus.includes("done")) &&
        (!travelStatus ||
          travelStatus.includes("pending") ||
          !logisticStatus ||
          logisticStatus.includes("pending"))
      ) {
        return (
          <div className={styles.actionColumn}>
            <div className={styles.actionColumnContent}>
            <Button
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
              onClick={() =>
                handleSubNavigation(
                  registration?.paymentTypeStatus,
                  registration?.travelToken,
                  registration?.paymentMode,
                  registration?.programRegistrationId,
                )
              }
            >
              update details
            </Button>
             {seatTransferred && selfTransferredSeat && <p>{ENT_TEXT_CONSTANTS.SEAT_TRANSFERRED_TEXT}</p>}
             </div>
          </div>
        );
      }
    }

    // Default case - no action button
    return null;
  };

  //To pause the animation video
  const handleTimeUpdate = () => {
    const video = videoRef?.current;
    if (video) {
      // Check if video is within 5 seconds of ending
      if (video.currentTime >= 8.0) {
        video.pause();
      }
    }
  };

  // Function to check if registration time has reached
  const checkRegistrationTime = () => {
    if (!programDetails?.registrationStartsAt) return;

    const now = new Date();
    const registrationStart = new Date(programDetails.registrationStartsAt);
    // console.log("Current Time:", now);
    // console.log("Registration Start Time:", registrationStart);

    if (now >= registrationStart) {
      setShowRegisterButton(true);
      setRegistrationMessage("");
      // Stop the interval once time is reached
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  };

  // Effect to handle registration window status
  useEffect(() => {
    if (!programDetails) return;

    const registrationWindowStatus = programDetails?.registrationWindowStatus;

    if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_OPENED) {
      setShowRegisterButton(true);
      setRegistrationMessage("");
    } else if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_NOT_OPENED) {
      setShowRegisterButton(false);

      if (programDetails?.registrationStartsAt) {
        const registrationStartDate = contentDateFormat(
          programDetails.registrationStartsAt,
        );
        const registrationStartTime = extractTime(
          programDetails.registrationStartsAt,
        );
        setRegistrationMessage(
          `Registrations for Entrainment 25 open on ${registrationStartDate} at ${registrationStartTime} IST`,
        );

        // Start checking every minute if registration time has reached
        intervalRef.current = setInterval(checkRegistrationTime, 1000);

        // Check immediately as well
        checkRegistrationTime();
      }
    } else if (registrationWindowStatus === ENT_TEXT_CONSTANTS.REG_CLOSED) {
      setShowRegisterButton(false);
      setRegistrationMessage(ENT_TEXT_CONSTANTS.REG_CLOSED_TEXT);
    }

    // Cleanup interval on component unmount or when dependencies change
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [programDetails]);

  // const handleRefresh = () => {
  //   fetchEntrainmentSeatsStatus();
  //   fetchEntrainmentRegistrations(true);
  // };
  // console.log("Registrations:", registrations);
  // console.log("Error:", error);
  // console.log("isWaitingList:", isWaitingList);
  useEffect(() => {
    const handleResize = (): void => {
      setIsMobileResolution(window.innerWidth <= 600);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={`${styles.programs_card}`}>
      <div className={styles.program_container}>
        {isMobileResolution ? (
          <div className={styles.mahatriaLogoMiobile}>
            <img
              src={mobileMahatriaImg}
              alt="mahatria-img-mobile"
              className={styles.mahatriaLogoMiobileImg}
            />
          </div>
        ) : (
          <div className={styles.program_banner_container}>
            {/* <img
            src={entrainmentBanner}
            alt="entrainment-Banner"
            className={styles.program_banner}
          /> */}
            <video
              ref={videoRef}
              src={
                window.innerWidth <= 768
                  ? mobileBannerAnimation
                  : animationVideo
              }
              disablePictureInPicture
              controlsList="noremoteplayback"
              autoPlay
              loop
              muted
              playsInline
              className={styles.video_banner}
              onTimeUpdate={handleTimeUpdate}
              onContextMenu={(e) => e.preventDefault()}
              controls={false}
              style={{ pointerEvents: "none" }}
            />
          </div>
        )}
        <div className={styles.program_logo_container}>
          <img
            src={entrainmentLogo}
            alt="entrainment-logo"
            className={styles.program_banner}
          />
        </div>
        <div className={styles.seprationLine}></div>

        <ProgramInfoCardV2
          checkinStartTime={formatTime(programDetails?.checkinAt)}
          checkinEndTime={formatTime(programDetails?.checkinEndsAt)}
          checkoutStartTime={formatTime(programDetails?.checkoutAt)}
          checkoutEndDate={contentDateFormat(programDetails?.checkoutAt, false)}
          checkinDate={contentDateFormat(programDetails?.checkinAt, false)}
          programFee={formatPriceWithCommas(programDetails?.programFee)}
          startsAt={contentDateFormat(programDetails?.startsAt, false)}
          endsAt={contentDateFormat(programDetails?.endsAt, false)}
          gstPercentage={
            stringToNumber(programDetails?.cgst) +
            stringToNumber(programDetails?.sgst)
          }
        />

        <div className={styles.descriptionTextContainer}>
          {/* <p>
            A multi-day residential experience with <span>Mahatria</span> to
            elevate personal transformation.
          </p>
          <p>15th August, 2025 10:00 a.m. to 11:15 a.m. IST</p> */}
          <p>
            <span className={styles.boldText}>Program venue: </span>Leonia
            Holistic Destination, Bommarasipet, Shamirpet Mandal,
            Medchal-Malkajgiri District, Hyderabad - 500078.{" "}
            <a
              href={endPoints.locationNavigation}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              view on maps
            </a>
          </p>
          <p className={styles.captionText}>
            *Early check-in and Late check-out not available
          </p>
        </div>
        {/* <div className={styles.registerButton}>
          <Button
            onClick={() => handleNavigation()}
            buttonClassName={styles.confirmButton}
            buttonTextClassName={styles.confirmText}
          >
            register
          </Button>
        </div> */}

        {showRegisterButton ? (
          <div className={styles.registerButton}>
            <Button
              onClick={() => handleNavigation()}
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
            >
              register
            </Button>
          </div>
        ) : (
          registrationMessage && (
            <p className={styles.regOpenDateText}>{registrationMessage}</p>
          )
        )}

        <div className={styles.registrationsListContainer}>
          {/* {registrations?.length > 0 && (
            <div className={styles.registrationHeader}>
              <p>
                <span className={styles.boldText}>Your registrations: </span>
                To fetch the latest status of your registrations, please{" "}
                <span className={styles.link} onClick={() => handleRefresh()}>
                  click here
                </span>
                .
              </p>
            </div>
          )} */}
          {registrations?.length > 0
            ? registrations?.map((registration) => (
                <>
                  <div className={styles.seprationLine}></div>
                  <div
                    key={registration?.programRegistrationId}
                    className={styles.registrationsLineItem}
                  >
                    <div className={styles.registrationDetails}>
                      <div className={styles.registrationId}>
                        {registration?.programRegistrationSeqNumber}
                      </div>
                      <div className={styles.nameColumn}>
                        {registration?.fullName}
                      </div>
                      <div className={styles.statusColumn}>
                        {getStatusContent(registration)}
                      </div>
                    </div>
                    <div className={styles.actionButtonWrapper}>
                      {renderActionButton(registration)}
                    </div>
                  </div>
                </>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default Entrainment;
